import { render, staticRenderFns } from "./EmployerSetupGuide.vue?vue&type=template&id=1aa21f2c&"
import script from "./EmployerSetupGuide.vue?vue&type=script&lang=js&"
export * from "./EmployerSetupGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports